import {ResourceIconPipe} from "./icons/resource.icone.pipe";
import {ResourceTemplatePipe} from "./template/resource.template.pipe";
import {AsiFilterPipe} from "./filter/asi.filter.pipe";
import {i18nModule} from "@config/i18n.module";
import {NgModule} from "@angular/core";
import {HttpModule} from "@angular/http";
import {CommonModule} from "@angular/common";
import {ResourcesModule} from "@resources/resources.module";

import {ResourceMultimediaPipe} from "./image/resource.multimedia.pipe";
// Form
import {FormsModule, ReactiveFormsModule} from "@angular/forms";

import {DigiCerbaCommonModule} from "@digicerba/common";

/** liste des components / directive à exporter */
var sharedDeclaration: Array<any> = [
  ResourceMultimediaPipe, AsiFilterPipe, ResourceTemplatePipe, ResourceIconPipe
];

/** liste des modules à exporter */
var sharedModules: Array<any> = [
  FormsModule, ReactiveFormsModule, CommonModule, ResourcesModule, i18nModule
];

/** Liste des composants interne au module */
var declarations: Array<any> = [];

/** Liste des services */
var services: Array<any> = [AsiFilterPipe];

/** Liste des composants necessitant la création d'une factory */
var entryComponents: Array<any> = [];

@NgModule({
  imports: [DigiCerbaCommonModule.forRoot(), HttpModule, ...sharedModules],
  declarations: [...sharedDeclaration, ...declarations, ...entryComponents],
  exports: [DigiCerbaCommonModule, ...sharedDeclaration, ...sharedModules],
  entryComponents: entryComponents,
  providers: services,
})
export class UtilsModule {
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-factures/digicerba-factures-web/src/angular/cerba/src/app/common/utils/utils.module.ts